export interface PasswordRequirements {
	hasMinLength: boolean;
	hasLowercase: boolean;
	hasUppercase: boolean;
	hasNumber: boolean;
	hasSpecialChar: boolean;
	noQuestionMark: boolean;
	isValid: boolean;
}

export const validatePassword = (password: string): PasswordRequirements => {
	const hasMinLength = password.length >= 8;
	const hasLowercase = /[a-z]/.test(password);
	const hasUppercase = /[A-Z]/.test(password);
	const hasNumber = /[0-9]/.test(password);
	const noQuestionMark = !password.includes("?");
	const hasSpecialChar = /[^A-Za-z0-9]/.test(password) && noQuestionMark;

	return {
		hasMinLength,
		hasLowercase,
		hasUppercase,
		hasNumber,
		hasSpecialChar,
		noQuestionMark,
		isValid:
			hasMinLength &&
			hasLowercase &&
			hasUppercase &&
			hasNumber &&
			hasSpecialChar &&
			noQuestionMark,
	};
};
